

































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import HhSurveilansService from "@/services/HhSurveilansService";
import MomentActionKeypad from "./MomentActionKeypad.vue";

const KATEGORI_LABELS: Record<string, string> = {
  dokter: "Dokter",
  perawat: "Perawat",
  bidan: "Bidan",
  ppa_lain: "PPA Lain",
  petugas_medis_lain: "Petugas Medis Lain",
  tenaga_penunjang: "Tenaga Penunjang",
  mahasiswa: "Mahasiswa",
  cleaning_service: "Cleaning Service"
};

@Component({ components: { MomentActionKeypad } })
export default class HhSurveilansObservasiLogger extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  pendingBuffer: any[] = [];
  submitting = false;

  filterMoment: string | null = null;
  filterAction: string | null = null;

  signDialog = false;
  password = "";
  overrideReason = "";

  minObservasi = 20;

  filterMomentOptions = [
    { text: "M1", value: "m1" },
    { text: "M2", value: "m2" },
    { text: "M3", value: "m3" },
    { text: "M4", value: "m4" },
    { text: "M5", value: "m5" }
  ];

  filterActionOptions = [
    { text: "HR", value: "hr" },
    { text: "HW", value: "hw" },
    { text: "TDK", value: "tdk" }
  ];

  headers = [
    { text: "Waktu", value: "waktu_observasi", width: 90 },
    { text: "Moment", value: "moment", width: 80 },
    { text: "Action", value: "action", width: 80 },
    { text: "Kategori", value: "kategori_petugas" },
    { text: "Tindakan", value: "catatan" },
    { text: "", value: "actions", sortable: false, width: 40 }
  ];

  async mounted() {
    await this.reload();
  }

  async reload() {
    const res = await HhSurveilansService.find(this.sessionId);
    this.session = res.data.data;
  }

  get indikasi() {
    return this.session ? this.session.observations.length : 0;
  }

  get totals() {
    if (!this.session) return { hr: 0, hw: 0, tdk: 0 };
    const obs = this.session.observations;
    return {
      hr: obs.filter((o: any) => o.action === "hr").length,
      hw: obs.filter((o: any) => o.action === "hw").length,
      tdk: obs.filter((o: any) => o.action === "tdk").length
    };
  }

  get complianceRate() {
    if (this.indikasi === 0) return 0;
    return ((this.totals.hr + this.totals.hw) / this.indikasi) * 100;
  }

  get complianceColor() {
    if (this.complianceRate >= 85) return "success";
    if (this.complianceRate >= 70) return "warning";
    return "error";
  }

  get progressToMin() {
    return Math.min(100, (this.indikasi / this.minObservasi) * 100);
  }

  get filteredObservations() {
    if (!this.session) return [];
    let data = this.session.observations;
    if (this.filterMoment) {
      data = data.filter((o: any) => o.moment === this.filterMoment);
    }
    if (this.filterAction) {
      data = data.filter((o: any) => o.action === this.filterAction);
    }
    return data;
  }

  bufferObservation(obs: any) {
    this.pendingBuffer.push(obs);
  }

  removeFromBuffer(idx: number) {
    this.pendingBuffer.splice(idx, 1);
  }

  async flushBuffer() {
    if (this.pendingBuffer.length === 0) return;
    this.submitting = true;
    try {
      await HhSurveilansService.bulkObservations(this.sessionId, this.pendingBuffer);
      this.pendingBuffer = [];
      await this.reload();
    } finally {
      this.submitting = false;
    }
  }

  async deleteObservation(item: any) {
    const alasan = prompt("Alasan menghapus observasi ini?");
    if (!alasan) return;
    await HhSurveilansService.destroyObservation(this.sessionId, item.id, alasan);
    await this.reload();
  }

  openSignDialog() {
    // Flush buffer first
    if (this.pendingBuffer.length > 0) {
      this.flushBuffer().then(() => {
        this.signDialog = true;
      });
      return;
    }
    this.signDialog = true;
  }

  async submitAuditor() {
    this.submitting = true;
    try {
      await HhSurveilansService.submitAuditor(this.sessionId, {
        password: this.password,
        override_min_observasi_reason: this.overrideReason
      });
      this.signDialog = false;
      this.password = "";
      this.overrideReason = "";
      this.$emit("submitted");
    } finally {
      this.submitting = false;
    }
  }

  kategoriLabel(code: string) {
    return KATEGORI_LABELS[code] || code;
  }

  formatTime(t: string) {
    if (!t) return "";
    const d = new Date(t.replace(" ", "T"));
    return d.toLocaleString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
  }
}
